import { render, staticRenderFns } from "./WorkRegistrationForm.vue?vue&type=template&id=aee22b4c&scoped=true&"
import script from "./WorkRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./WorkRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./WorkRegistrationForm.vue?vue&type=style&index=0&id=aee22b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee22b4c",
  null
  
)

export default component.exports